import { observable, set, action } from 'mobx';
import Salon from './Salon';

export interface IUserSalon {
  nearbySalons: Salon[];
  selectedSalonId: string;
  stylistName: string;
  isPrivacyPolicyAccepted: boolean;
}

class UserSalon {
  @observable nearbySalons: Salon[] = [];

  @observable selectedSalonId = '';

  @observable stylistName = '';

  @observable isPrivacyPolicyAccepted = false;

  @action
  update(data: Partial<IUserSalon>): void {
    set(this, data);
  }

  static fromJSON(data: IUserSalon): UserSalon {
    const userSalon = new UserSalon();
    set(userSalon, data);

    return userSalon;
  }
}

export default UserSalon;
